<template>
  <div class="product-actions">
    <div class="units">
      <button class="btn btn-light" @click="delUnit"><i class="fa fa-minus"/></button>
      <span class="form-control uds">{{ uds }}</span>
      <button class="btn btn-light" @click="addUnit"><i class="fa fa-plus"/></button>
    </div>
    <button class="btn btn-info btn-add" @click="addToCart">
      <i class="fa fa-cart-plus" />
      <span>{{ total }}€</span>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    product: { required: true },
    total: { required: true }
  },
  data() {
    return {
      uds: 1
    }
  },
  methods: {
    addUnit() {
      this.uds += 1
      this.$emit('udsChanged', this.uds)
    },
    delUnit() {
      const nextUds = this.uds - 1
      if (nextUds === 0) {
        if (confirm('¿Quieres borrar este producto?'))
          this.$emit('closeAddModal')
      } else {
        this.uds = nextUds
        this.$emit('udsChanged', this.uds)
      }
    },
    addToCart() {
      this.$emit('addToCart')
    }
  }
}
</script>

<style lang="scss">
.product-actions {
  .uds {
    color: #353a40;
    font-weight: bold;
  }
  .btn-light {
    color: #353a40;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Order/OrderAddProductModal/ProductActions.vue